import type { FeatureConfig } from '@skynet/feature-config';
import { DEX_EXCHANGES_LIST_URL, DEX_EXCHANGES_ROUTE_PATH } from './routes';

/**
 * Feature manifest for the DEX Exchanges list page, the first feature of the
 * DEX domain. The dashboard shell reads this single source of truth instead of
 * hardcoding the route, header label and Cerbos action across its routing,
 * navigation, header and access-control modules.
 *
 * `route.load` is a dynamic-import thunk, so importing this config for its
 * nav/header metadata never pulls the page implementation into the main bundle.
 *
 * `nav` is declared because `FeatureConfig` requires it, but the dashboard does
 * not list it in the DEX sidebar: the Exchanges entry is hidden there today and
 * the page is reached by URL only. Its `icon` is `null` so the boot path does
 * not load `@ant-design/icons` for an entry that never renders. `section`, `nav.key` and `cerbosAction` stay literal:
 * they are the identifier the Cerbos policy is written against
 * (`read:dex:exchanges`).
 */
export const dexExchangesConfig = {
  domain: 'DEX',
  section: 'exchanges',
  route: {
    path: DEX_EXCHANGES_ROUTE_PATH,
    load: async () => ({ default: (await import('./Exchanges')).Exchanges }),
  },
  nav: {
    key: 'dex.exchanges',
    label: 'Exchanges',
    icon: null,
    url: DEX_EXCHANGES_LIST_URL,
  },
  header: { label: 'EXCHANGES' },
  cerbosAction: 'read:dex:exchanges',
  needsEntityId: false,
} as const satisfies FeatureConfig;
